/**
 * Market Weather (Phase 9), the look of it, with no three.js (tested in Node).
 *
 * The backend (world_view.weather_for) says, per country:
 *   sky        clear | fair | hazy | overcast | storm   (from the economic cycle)
 *   wind       0..1                                     (from the currency's volatility)
 *   lightning  true where a risk incident just hit (your HQ)
 *
 * weatherLook(weather) turns that into what scene.js draws: cloud puffs over
 * the country on the globe, and rain, fog and flashes in its district.
 */
const SKY_LOOK = {
  clear: { puffs: 0, color: 0xffffff, opacity: 0, rain: 0, fog: 0 },
  fair: { puffs: 1, color: 0xf4f7ff, opacity: 0.35, rain: 0, fog: 0 },
  hazy: { puffs: 3, color: 0xf2c58a, opacity: 0.35, rain: 0, fog: 0.004 },
  overcast: { puffs: 4, color: 0xa9b3c9, opacity: 0.6, rain: 0.35, fog: 0.008 },
  storm: { puffs: 6, color: 0x5b6378, opacity: 0.8, rain: 1, fog: 0.014 },
};

function weatherLook(w) {
  const sky = (w && SKY_LOOK[w.sky]) ? w.sky : "fair";
  const look = SKY_LOOK[sky];
  const wind = Math.max(0, Math.min(1, (w && w.wind) || 0));
  const flash = !!(w && w.lightning);
  return {
    sky, ...look,
    puffs: flash ? Math.max(look.puffs, 4) : look.puffs,        // lightning needs a cloud to come from
    color: flash && sky !== "storm" ? 0x6b7390 : look.color,
    drift: 0.15 + wind * 1.6,                                   // radians a second the clouds circle at
    slant: wind * 0.6,                                          // rain leans with the wind
    flash,
  };
}

const WEATHER_ICON = { clear: "☀️", fair: "🌤", hazy: "🌫", overcast: "☁️", storm: "⛈" };

export { WEATHER_ICON, weatherLook };
